import { Aggregator } from "./aggregator";
import {
  AggregatorAction,
  AggregatorGetSuccessActionType,
  AggregatorSetActionType,
  ReferrerClickIdSetActionType,
} from "./aggregator.actions";

export function aggregatorReducer(
  state: AggregatorState = {},
  action: AggregatorAction
) {
  switch (action.type) {
    case AggregatorGetSuccessActionType:
      return {
        ...state,
        aggregator: action.aggregator,
      };
    case AggregatorSetActionType:
      return {
        ...state,
        bid: action.bid,
      };
    case ReferrerClickIdSetActionType:
      return {
        ...state,
        referrerClickId: action.referrerClickId,
      };

    default:
      return state;
  }
}

export interface AggregatorState {
  aggregator?: Aggregator;
  bid?: string;
  referrerClickId?: string;
}
